export const TRANSLATIONS: { [x: string]: string } = {
    da_DK: 'da_DK',
    en_US: 'en_US',
    da: 'da_DK',
    en: 'en_US',
};
